exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-control-drag-handle{background-color:var(--ds-color-london-20);height:100%;position:relative;width:.25rem}.ds-control-drag-handle__thumb{left:-.875rem;position:absolute;top:calc(50% - .875rem)}.ds-control-drag-handle--horizontal{height:.25rem;width:100%}.ds-control-drag-handle--horizontal .ds-control-drag-handle__thumb{left:calc(50% - .875rem);top:-.875rem}.ds-control-drag-handle--disabled{background-color:var(--ds-color-london-95);cursor:not-allowed}.ds-control-drag-handle--inverse{background-color:var(--ds-color-london-100)}.ds-control-drag-handle--inverse.ds-control-drag-handle--disabled{background-color:#666;cursor:not-allowed}", ""]);

// exports
exports.locals = {
	"ds-control-drag-handle": "ds-control-drag-handle",
	"ds-control-drag-handle__thumb": "ds-control-drag-handle__thumb",
	"ds-control-drag-handle--horizontal": "ds-control-drag-handle--horizontal",
	"ds-control-drag-handle--disabled": "ds-control-drag-handle--disabled",
	"ds-control-drag-handle--inverse": "ds-control-drag-handle--inverse"
};